import { createSlice } from '@reduxjs/toolkit';

export const dropdownSlice = createSlice({
  name: 'dropdowns',
  initialState: {
    criticalLevel: {values: []}, 
    ethnicity: {values: []}, 
    gender: {values: []}, 
    relationship: {values: []},
    contentType: {values: []}, 
    speciality: {values: []}, 
    staffTitles: {values: []}, 
    phases: {values: []}, 
    countryCode: {values: []}, 
    stateCode: {values: []},
    addressType: {values: []},
    specialty: {values: []},
    modality: {values: []},
    countries: [],
  },
  reducers: {
    setDropdowns: (state, action) => {
      Object.assign(state, action.payload);
    },
    setDropdownKeyValues: (state, action) => {
      const {key, values} = action.payload;
      state[key] = {values: values}
    },
  },
});

export const { setDropdowns, setDropdownKeyValues } = dropdownSlice.actions;

export default dropdownSlice.reducer;
